module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fc-Ga-Hc-Id-Ja.83044516.png";